import {
    CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
    CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE,
    FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS,
    FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_FAILURE,
    EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL,
    EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE,
} from './Create/action';
import {
    AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_SUCCESS,
    AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_FAILURE
} from './List/action'
const initialState = {
    createAutomatedOverriddingRiskFactorSuccess: null,
    createAutomatedOverriddingRiskFactorFailure: null,
    automatedOverriddingRiskList: null,
    automatedOverriddingRiskListError: null,
    automatedOverriddingRiskFactorDetails: null,
    automatedOverriddingRiskFactorDetailsError: null,
    editSuccess: null,
    editFailed: null
}
const automatedOverriddingRiskFactorReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL:
            return state = {
                ...state,
                createAutomatedOverriddingRiskFactorSuccess: action.data
            }
        case CREATE_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE:
            return state = {
                ...state,
                createAutomatedOverriddingRiskFactorFailure: action.data
            }
        case AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_SUCCESS:
            return state = {
                ...state,
                automatedOverriddingRiskList: action.data
            }
        case AUTOMATED_OVERRIDDING_RISKFACTOR_LIST_FAILURE:
            return state = {
                ...state,
                automatedOverriddingRiskListError: action.data
            }
        case FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_SUCCESS:
            return state = {
                ...state,
                automatedOverriddingRiskFactorDetails: action.data
            }
        case FETCH_AUTOMATED_OVERIDDING_RISKFACTOR_DETAILS_FAILURE:
            return state = {
                ...state,
                automatedOverriddingRiskFactorDetailsError: action.data
            }
        case EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_SUCCESSFULL:
            return state = {
                ...state,
                editSuccess: action.data
            }
        case EDIT_AUTOMATED_OVERRIDDING_RISKFACTOR_FAILURE:
            return state = {
                ...state,
                editFailed: action.data
            }
        default: return state
    }
}

export default automatedOverriddingRiskFactorReducer;